export default __webpack_public_path__ + "static/media/ronds-confirmation-formulaire.352e69e2.svg";